import React, { PureComponent } from "react";
import {
  TransContext,
  LoginContext,
  CompositionContext,
  FixturesContext,
  GamedaysContext,
  GamerCardContext,
  PlayersStatisticsContext,
  PlayerListContext,
  TeamDataContext,
  ConstraintsContext,
} from "../../Context";
import OutsideNotifier from "../OutsideNotifier";
import { Consume } from "../../Context/Consumer";
import config from "../../common/config";
import {
  getData,
  getLoginCookie,
  getTrans,
  isDisabled,
  isNumberKey,
  validateEmail,
  validateUsername,
  getLocalStorage,
  setLocalStorage,
  googleAnalyticsEventTracking,
  getGamedayStatus,
  makeManageTeamSkeleton,
} from "../../common";
import { get } from "jquery";
import { Scrollbars } from "react-custom-scrollbars";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import { debounce } from "lodash";
import ToastMsg from "../toastMsg";
class LoginPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: true,
      mobileNo: "",
      countryCode: "+971(UAE)",
      isCntrDrpDwnOpen: false,
      isCountryCodeOpen: false,
      objOTPStrng: { first: "", second: "", third: "", fourth: "" },
      objEmailOTPStrng: { first: "", second: "", third: "", fourth: "" },
      objCountry: props.CompositionData.countriesList[0],
      favClub: {},
      city: {},
      emailId: getLoginCookie() ? getLoginCookie()?.EmailId : "",
      userName: "",
      isCityDrpdwnOpen: false,
      isFavClubDrpdwnOpen: false,
      objEmailErr: { isShow: false, errMsg: "" },
      objMobileErr: { isShow: false, errMsg: "" },
      isValidated: false,
      isOtpInvalid: false,
      isContinueEnable: false,
      countryCodeSearch: "",
      loginCookieData: {},
      showEmail: false,
      isEmailInvalid: false,
      errorObj: {
        heading: "",
        para1: "",
        para2: "",
        btnTxt: "",
        btnAction: "",
      },
      objDuration: {},
    };
    this.timerID = null;
  }

  componentWillUnmount = () => {
    clearInterval(this.timerID);
  };

  onClose = () => {
    let self = this;
    self.props.loginData.setIsShowLoginPopup(false);
    let loginCookie = getLoginCookie();
    loginCookie &&
      (!loginCookie.IsRegistered || !loginCookie.IsVerified) &&
      self.props.loginData.makeLogoutCall({ isReload: true });
    self.props.loginData.setObjShowHideLogin({
      screenMode: config.loginScreenMode.main,
    });
    clearAllBodyScrollLocks();
  };

  socialLogin = (social) => {
    console.log(window.location.host);
    window.location.replace(
      window.location.origin +
        config.BASE_DOMAIN +
        config.WebConfig[config.APINames.Login]
          .replace("{{clientId}}", social)
          .replace("{{cbUrl}}", window.location.href) +
        "&buster=" +
        Date.now()
    );
  };

  linkingSocialLogin = (social) => {
    setLocalStorage("setCustomSocial", true);
    this.socialLogin(social);
  };
  updatedMobileNo = (event) => {
    let self = this;
    let { state, props, submitMobileNoForOTP } = self;
    let isNumber = isNumberKey(event);
    if ((event.which ? event.which : event.keyCode) === 13) {
      if (
        props.loginData.objShowHideLogin.screenMode ===
        config.loginScreenMode.mobileNo
      ) {
        submitMobileNoForOTP();
      }
    } else {
      let mobile = state.mobileNo + event.key;
      if (isNumber && mobile.length <= config.MAX_PHONE_LENGTH) {
        self.setState({
          mobileNo: mobile,
          isContinueEnable:
            mobile.length > config.MIN_PHONE_LENGTH &&
            mobile.length <= config.MAX_PHONE_LENGTH,
        });
      } else {
        self.setState({
          mobileNo: state.mobileNo,
        });
      }
    }
  };

  updatedEmailId = (event) => {
    let self = this;
    let { state, props, customEmailLogin, customEmailVerify } = self;
    if ((event.which ? event.which : event.keyCode) === 13) {
      if (
        props.loginData.objShowHideLogin.screenMode ===
        config.loginScreenMode.main
      ) {
        customEmailLogin();
      } else if (
        props.loginData.objShowHideLogin.screenMode ===
        config.loginScreenMode.linkNewLogin
      ) {
        customEmailVerify();
      }
    } else {
      let email = self.state.emailId.slice(0, -1);
      if (validateEmail(email)) {
        self.setState({
          emailId: state.emailId,
          isContinueEnable: validateEmail(email),
        });
      } else {
        self.setState({
          emailId: state.emailId,
        });
      }
    }
  };

  onChangeEmailId = (event) => {
    let self = this;
    if ((event.which ? event.which : event.keyCode) === 8) {
      let emailId = self.state.emailId.slice(0, -1);
      self.setState({
        emailId: emailId,
        isContinueEnable: validateEmail(emailId),
      });
    }
  };

  onChangeMobileNo = (event) => {
    let self = this;
    if ((event.which ? event.which : event.keyCode) === 8) {
      let mobile = self.state.mobileNo.slice(0, -1);
      self.setState({
        mobileNo: mobile,
        isContinueEnable: mobile.length > config.MIN_PHONE_LENGTH,
      });
    }
  };

  validateFields = () => {
    let self = this;
    let { state, props } = self;
    let { objCountry, city, favClub, emailId, userName } = state;
    if (
      /* validateEmail(emailId) && */
      validateUsername(userName) &&
      Object.keys(objCountry).length &&
      (objCountry.cities.length ? Object.keys(city).length : true) &&
      Object.keys(favClub).length
    ) {
      self.setState({ isValidated: true });
    } else {
      self.setState({ isValidated: false });
    }
  };

  selectCountryCode = (objCountry) => {
    let self = this;
    self.setState({
      countryCode: `${objCountry.DialingCode}(${objCountry.ShortCode})`,
      objCountry: objCountry,
    });
  };

  selectCountry = (objCountry) => {
    let self = this;
    self.setState(
      {
        objCountry: objCountry,
      },
      () => {
        self.validateFields();
      }
    );
  };

  selectCity = (city) => {
    let self = this;
    self.setState(
      {
        city: city,
      },
      () => {
        self.validateFields();
      }
    );
  };

  showHideCountryDropdown = (toggle) => {
    let self = this;
    self.setState({
      isCntrDrpDwnOpen: toggle,
    });
    toggle && self.refCntrCode.focus();
    this.setState({ countryCodeSearch: "" });
  };
  showHideCountryCodeDropdown = (toggle) => {
    let self = this;
    self.setState({
      isCountryCodeOpen: toggle,
    });
    toggle && self.refCntCode.focus();
    this.setState({ countryCodeSearch: "" });
  };

  submitMobileNoForOTP = () => {
    /* clearAllBodyScrollLocks(); */

    let self = this;
    let { state, props } = self;
    let apiParams = {
      optType: 1,
      userId: 0,
      socialId: "",
      clientId: 5,
      platformId: config.platformId,
      fullName: "",
      emailId: "",
      countryId: 0,
      favTeamId: "",
      phoneNo: state.mobileNo,
      otp: "",
      countryCode: state.countryCode.split("(")[0],
      language: config.language,
    };

    props.loginData.submitMobileNo(
      apiParams,
      (resp) => {
        console.log(resp?.Meta?.RetVal);
        props.loginData.setUserData({
          mobileNo: state.mobileNo,
          countryCode: state.countryCode,
        });
        props.loginData.setObjShowHideLogin({
          screenMode: config.loginScreenMode.otp,
          isTimer: true,
        });
        self.initiateOTPTimer();
        this.ref0.focus();
      },
      (error) => {
        console.log(error);
        let retVal = error.RetVal;
        if (retVal === 10002) {
          window.history.replaceState(null, null, window.location.pathname);
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.unableRegister,
          });
          self.props.loginData.setIsShowLoginPopup(true);
          self.setState({
            isCheckedForLoginParams: true,
            mobileNo: "",
            countryCode: "+971(UAE)",
          });
        }
        if (retVal === 10004 || retVal === 10003) {
          window.history.replaceState(null, null, window.location.pathname);
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.availableAccounts,
          });
          self.props.loginData.setIsShowLoginPopup(true);
          let showEmail = retVal === 10003 ? false : true;
          self.setState({
            isCheckedForLoginParams: true,
            loginCookieData: error.ErrVal.Data.Value,
            mobileNo: "",
            countryCode: "+971(UAE)",
            showEmail: showEmail,
          });
        }
      }
    );
  };

  getOTPString = () => {
    let self = this;
    let { first, second, third, fourth } = self.state.objOTPStrng;
    let otpStrng =
      first.toString() +
      second.toString() +
      third.toString() +
      fourth.toString();
    return otpStrng;
  };
  getEmailOTPString = () => {
    let self = this;
    let { first, second, third, fourth } = self.state.objEmailOTPStrng;
    let otpStrng =
      first.toString() +
      second.toString() +
      third.toString() +
      fourth.toString();
    return otpStrng;
  };

  onChangeOTP = (event, position, isCustomOTP) => {
    let self = this;
    let { state, makeOTPCall, checkForOTPValidation } = self;
    let isNumber = isNumberKey(event);

    if (isNumber && (event.which ? event.which : event.keyCode) !== 13) {
      let value = event.key;
      switch (position) {
        case 1:
          self.setState(
            (prevState) => ({
              ...prevState,
              objOTPStrng: {
                ...prevState.objOTPStrng,
                first: value,
              },
            }),
            () => {
              checkForOTPValidation() && makeOTPCall(isCustomOTP);
            }
          );
          this.ref1.focus();
          break;
        case 2:
          self.setState(
            (prevState) => ({
              ...prevState,
              objOTPStrng: {
                ...prevState.objOTPStrng,
                second: value,
              },
            }),
            () => {
              checkForOTPValidation() && makeOTPCall(isCustomOTP);
            }
          );
          this.ref2.focus();
          break;
        case 3:
          self.setState(
            (prevState) => ({
              ...prevState,
              objOTPStrng: {
                ...prevState.objOTPStrng,
                third: value,
              },
            }),
            () => {
              checkForOTPValidation() && makeOTPCall(isCustomOTP);
            }
          );
          this.ref3.focus();
          break;
        case 4:
          self.setState(
            (prevState) => ({
              ...prevState,
              objOTPStrng: {
                ...prevState.objOTPStrng,
                fourth: value,
              },
            }),
            () => {
              checkForOTPValidation()
                ? makeOTPCall(isCustomOTP)
                : self.ref0.focus();
            }
          );
          break;
        default:
          break;
      }
    } else {
      self.setState({
        objOTPStrng: state.objOTPStrng,
      });
    }
    clearAllBodyScrollLocks();
  };

  onChangeEmailOTP = (event, position, isCustomOTP) => {
    let self = this;
    let { state, makeEmailOTPCall, checkForEmailOTPValidation } = self;
    let isNumber = isNumberKey(event);

    if (isNumber && (event.which ? event.which : event.keyCode) !== 13) {
      let value = event.key;
      switch (position) {
        case 1:
          self.setState(
            (prevState) => ({
              ...prevState,
              objEmailOTPStrng: {
                ...prevState.objEmailOTPStrng,
                first: value,
              },
            }),
            () => {
              checkForEmailOTPValidation() && makeEmailOTPCall(isCustomOTP);
            }
          );
          this.ref1.focus();
          break;
        case 2:
          self.setState(
            (prevState) => ({
              ...prevState,
              objEmailOTPStrng: {
                ...prevState.objEmailOTPStrng,
                second: value,
              },
            }),
            () => {
              checkForEmailOTPValidation() && makeEmailOTPCall(isCustomOTP);
            }
          );
          this.ref2.focus();
          break;
        case 3:
          self.setState(
            (prevState) => ({
              ...prevState,
              objEmailOTPStrng: {
                ...prevState.objEmailOTPStrng,
                third: value,
              },
            }),
            () => {
              checkForEmailOTPValidation() && makeEmailOTPCall(isCustomOTP);
            }
          );
          this.ref3.focus();
          break;
        case 4:
          self.setState(
            (prevState) => ({
              ...prevState,
              objEmailOTPStrng: {
                ...prevState.objEmailOTPStrng,
                fourth: value,
              },
            }),
            () => {
              checkForEmailOTPValidation()
                ? makeEmailOTPCall(isCustomOTP)
                : self.ref0.focus();
            }
          );
          break;
        default:
          break;
      }
    } else {
      self.setState({
        objEmailOTPStrng: state.objEmailOTPStrng,
      });
    }
    clearAllBodyScrollLocks();
  };

  onUpdateOTP = (event, position) => {
    let self = this;
    if ((event.which ? event.which : event.keyCode) === 8) {
      switch (position) {
        case 1:
          self.setState((prevState) => ({
            ...prevState,
            objOTPStrng: {
              ...prevState.objOTPStrng,
              first: "",
            },
          }));
          this.ref0.focus();
          break;
        case 2:
          self.setState((prevState) => ({
            ...prevState,
            objOTPStrng: {
              ...prevState.objOTPStrng,
              second: "",
            },
          }));
          this.ref1.focus();
          break;
        case 3:
          self.setState((prevState) => ({
            ...prevState,
            objOTPStrng: {
              ...prevState.objOTPStrng,
              third: "",
            },
          }));
          this.ref2.focus();
          break;
        case 4:
          self.setState((prevState) => ({
            ...prevState,
            objOTPStrng: {
              ...prevState.objOTPStrng,
              fourth: "",
            },
          }));
          this.ref3.focus();
          break;
        default:
          break;
      }
    }
  };

  onUpdateEmailOTP = (event, position) => {
    let self = this;
    if ((event.which ? event.which : event.keyCode) === 8) {
      switch (position) {
        case 1:
          self.setState((prevState) => ({
            ...prevState,
            objEmailOTPStrng: {
              ...prevState.objEmailOTPStrng,
              first: "",
            },
          }));
          this.ref0.focus();
          break;
        case 2:
          self.setState((prevState) => ({
            ...prevState,
            objEmailOTPStrng: {
              ...prevState.objEmailOTPStrng,
              second: "",
            },
          }));
          this.ref1.focus();
          break;
        case 3:
          self.setState((prevState) => ({
            ...prevState,
            objEmailOTPStrng: {
              ...prevState.objEmailOTPStrng,
              third: "",
            },
          }));
          this.ref2.focus();
          break;
        case 4:
          self.setState((prevState) => ({
            ...prevState,
            objEmailOTPStrng: {
              ...prevState.objEmailOTPStrng,
              fourth: "",
            },
          }));
          this.ref3.focus();
          break;
        default:
          break;
      }
    }
  };

  checkForOTPValidation = () => {
    let self = this;
    let { first, second, third, fourth } = self.state.objOTPStrng;
    if (first && second && third && fourth) {
      return true;
    } else {
      return false;
    }
  };
  checkForEmailOTPValidation = () => {
    let self = this;
    let { first, second, third, fourth } = self.state.objEmailOTPStrng;
    if (first && second && third && fourth) {
      return true;
    } else {
      return false;
    }
  };

  makeEmailOTPCall = (isCustomOTP) => {
    let self = this;
    let { customEmailLogin, props, state, getEmailOTPString } = self;
    if (isCustomOTP) {
      customEmailLogin(true);
    } else {
      let apiParams = {
        optType: 2,
        platformId: config.platformId,
        emailId: state.emailId,
        otp: getEmailOTPString(),
        clientId: 5,
        language: config.language,
      };

      props.loginData.submitEmail(
        apiParams,
        (resp) => {
          props.loginData.setIsShowLoginPopup(false);
          clearAllBodyScrollLocks();
          self.props.showHideToast(
            true,
            getTrans(
              props.TransData.data,
              "auth_v2_account_link_success_msg",
              "Account linked Successfully"
            ),
            false
          );
          self.makeUserGamedaysCall();

          /* if (retVal === 1) {
          } */
        },
        (error) => {
          let retVal = error.RetVal;
          self.setState({
            objEmailOTPStrng: {
              first: "",
              second: "",
              third: "",
              fourth: "",
            },
          });

          if (retVal === 1001) {
            self.setState({
              isOtpInvalid: true,
            });
            self.ref0.focus();
          }
          if (retVal === 1006 || retVal === 1011) {
            self.props.loginData.setIsShowLoginPopup(false);
            self.props.loginData.makeLogoutCall({ isReload: true });
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.main,
            });
          }
          if (retVal === 1005) {
            self.props.loginData.setIsShowLoginPopup(false);
            self.props.loginData.makeLogoutCall({ isReload: false });
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.main,
            });
            self.props.showHideToast(
              true,
              getTrans(
                props.TransData.data,
                "User_not_found",
                "User not found"
              ),
              true
            );
          }
          if (retVal === 10010) {
            self.props.loginData.setIsShowLoginPopup(false);
            self.props.showHideToast(
              true,
              getTrans(
                self.props.TransData.data,
                "auth_v2_unable_to_link_c_custom_10010_msg",
                "Email is black listed {{email_id}}"
              ).replace("{{email_id}}", state.emailId),
              true
            );
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.main,
            });
          }
          if (retVal === 2003) {
            let msg = getTrans(
              self.props.TransData.data,
              "auth_v2_unable_to_link_c_custom_2003_msg",
              "Social Id mis matched for {{email_id}}"
            ).replace("{{email_id}}", getLoginCookie().EmailId);
            self.props.showHideToast(true, msg, true);
          }
        }
      );
    }
  };
  makeOTPCall = (isCustomOTP) => {
    let self = this;
    let { customLogin, props, state, getOTPString } = self;
    if (isCustomOTP) {
      customLogin(true);
    } else {
      let apiParams = {
        optType: 2,
        userId: 0,
        socialId: "",
        clientId: 5,
        platformId: 1,
        fullName: "",
        emailId: "",
        countryId: 0,
        favTeamId: "",
        phoneNo: props.loginData.userData.mobileNo,
        countryCode: props.loginData.userData.countryCode.split("(")[0],
        otp: getOTPString(),
        language: config.language,
      };
      props.loginData.submitMobileNo(
        apiParams,
        (resp) => {
          let retVal = resp.Value.retval;
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.linkNewLogin,
          });
          self.setState({
            emailId: getLoginCookie()?.EmailId,
          });

          /* if (retVal === 1) {
          } */
        },
        (error) => {
          let retVal = error.RetVal;
          self.setState({
            objOTPStrng: {
              first: "",
              second: "",
              third: "",
              fourth: "",
            },
          });
          /* if (retVal === 2001) {
            props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.linkAccounts,
            });
          }
          if (retVal === 2) {
            props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.register,
            });
          } */
          if (retVal === 1001) {
            self.setState({
              isOtpInvalid: true,
            });
            self.ref0.focus();
          }
          /* if (retVal === 2002) {
            props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.changeNumber,
            });
          } */
        }
      );
    }
  };

  onChangeEmail = (event) => {
    let self = this;
    self.setState(
      {
        emailId: event.target.value,
      },
      () => {
        self.validateFields();
      }
    );
  };

  onChangeUserName = (event) => {
    let self = this;
    self.setState(
      {
        userName: event.target.value,
      },
      () => {
        self.validateFields();
      }
    );
  };

  showHideCityDropdown = (toggle) => {
    let self = this;
    self.setState({
      isCityDrpdwnOpen: toggle,
    });
  };
  showHideFavClubDrpdwn = (toggle) => {
    let self = this;
    self.setState({
      isFavClubDrpdwnOpen: toggle,
    });
  };

  onChangeFavClub = (club) => {
    let self = this;
    self.setState(
      {
        favClub: club,
      },
      () => {
        self.validateFields();
      }
    );
  };

  registerUser = (isLink) => {
    let leagueCode = getLocalStorage("lgCod");
    let leagueName = getLocalStorage("lgNam");
    let LguserName = getLocalStorage("UsrNam");

    clearAllBodyScrollLocks();

    let self = this;
    let { state, props, makeUserGamedaysCall } = self;
    let { emailId, userName, objCountry, city, favClub, mobileNo } = state;
    let { loginData } = props;
    let loginCookie = getLoginCookie();
    let gdprValue = getLocalStorage("setGDPR");
    let apiParams = {
      optType: isLink ? 3 : 2,
      userId: 0,
      socialId: "",
      clientId: isLink ? 0 : loginCookie.ClientId,
      /* socialId: isLink ? "" : loginData.data.Value.usrsocid,
      clientId: isLink ? 0 : loginData.data.Value.usrclnid, */
      platformId: config.platformId,
      fullName: isLink ? "" : userName,
      emailId: isLink ? "" : loginCookie.EmailId,
      phoneNo: mobileNo,
      countryId: isLink ? 0 : objCountry.Id,
      stateId: isLink ? 0 : objCountry.cities?.length ? city.Id : 0,
      favTeamId: isLink ? "" : favClub.TeamId,
      isGDPRAccepted: (isLink ? 3 : 2) && gdprValue ? 1 : 0,
      countryCode: isLink ? 0 : objCountry.DialingCode,
    };

    loginData.registerUser(
      apiParams,
      (resp) => {
        loginData.setIsShowLoginPopup(false);
        makeUserGamedaysCall();
        self.props.showHideToast(
          true,
          getTrans(
            props.TransData.data,
            "registration_completed_successfully",
            "Registration completed successfully"
          ),
          false
        );
        if (isLink) {
        }
        if (leagueCode && leagueName && LguserName) {
          setLocalStorage("lgCod", "");
          setLocalStorage("lgNam", "");
          setLocalStorage("UsrNam", "");
          console.log(self.props);
          window.location.replace(
            `${config.BASE_DOMAIN_LANG}leagues/${leagueCode}/${leagueName}/${userName}`
          );
        }
      },
      (error) => {
        let retVal = error.RetVal;
        console.log(error);
        if (isLink && retVal === 1004) {
          self.props.loginData.setIsShowLoginPopup(false);
          self.props.loginData.makeLogoutCall({ isReload: false });
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.main,
          });
          self.props.showHideToast(
            true,
            getTrans(props.TransData.data, "User_not_found", "User not found"),
            true
          );
        } else if (retVal === 10011) {
          self.setState({
            objMobileErr: { isShow: true },
          });
        }
      }
    );
  };
  redirectToOTP = () => {
    let self = this;
    self.props.loginData.setUserData(null);
    self.setState({
      emailId: "",
    });
    self.props.loginData.setObjShowHideLogin({
      screenMode: config.loginScreenMode.main,
    });
  };

  makeUserGamedaysCall = () => {
    let self = this;
    let loginCookie = getLoginCookie();
    self.props.Gamedays.makeGamedaysCall(
      {},
      (res) => {
        if (res?.Meta?.RetVal === 1) {
          self.props.Gamedays.setIsGamedaysCalled(true);
          let userPlayerdGamedayIds = res.Data.Value.Gamedays;
          let fix = self.props.FixturesData.data.find((a) => {
            return (
              a.GDIsCurrent === 1 &&
              a.GDIsLocked === 1 &&
              userPlayerdGamedayIds.find((b) => {
                return b.GamedayId === a.GamedayId;
              })?.GamedayId
            );
          });
          if (!fix?.GamedayId) {
            fix = self.props.FixturesData.data.find((a) => {
              return (
                a.GamedayId ===
                res?.Data?.Value?.CurrentGameday?.CurrentGamedayId
              );
            });
          }
          let currentMatchDay = fix;
          self.props.FixturesData.setCurrMatchDay(currentMatchDay);
          self.props.FixturesData.setCurrMatchDayDefault(currentMatchDay);
          if (userPlayerdGamedayIds.length) {
            let params = {
              optType: config.optType,
              gamedayId: fix.GamedayId,
              phaseId: fix.PhaseId,
              language: config.language,
            };
            self.props.Gamedays.getSelectedTeam(
              params,
              (response) => {
                let mode = getGamedayStatus(fix);
                self.props.FixturesData.setGameMode(mode);
                let teamDataSkeleton = makeManageTeamSkeleton(
                  response?.Data?.Value,
                  self.props.PlayerListData.rawPlayerList,
                  self.props.CompositionData.data
                );
                self.props.TeamData.setTeamData(teamDataSkeleton.teamData);

                if (mode === config.modes.live) {
                  self.props.TeamData.setLiveTeamData(
                    teamDataSkeleton.teamData
                  );
                }
              },
              () => {}
            );
          } else {
            self.props.FixturesData.setScreenMode(
              config.screenMode["create-team"]
            );
            self.props.FixturesData.setGameMode(config.modes.transfer);
          }
          !self.props.GamerCard.isGamerCardLoading &&
            self.props.GamerCard.getGameCard(
              {
                optTye: config.optType,
                platformId: loginCookie ? loginCookie.PlatformId : 0,
                clientId: loginCookie ? loginCookie.ClientId : 1,
              },
              () => {}
            );
          !self.props.PlayersStatisticsData.isPlrStatsLoading &&
            self.props.PlayersStatisticsData.getPlayerStatistics(
              { lang: config.language },
              () => {}
            );
        }
      },

      (error) => {
        console.log(error);
      }
    );
  };

  customEmailLogin = (isSubmitOTP) => {
    const { action, category, label } = config.trackclickEvents.customLogin;
    let leagueCode = getLocalStorage("lgCod");
    let leagueName = getLocalStorage("lgNam");
    let userName = getLocalStorage("UsrNam");
    googleAnalyticsEventTracking(action, category, label);
    let self = this;
    let { state, props, getEmailOTPString, makeUserGamedaysCall } = self;
    let apiParams = {
      optType: isSubmitOTP ? 2 : 1,
      userId: 0,
      socialId: "",
      clientId: 5,
      platformId: config.platformId,
      fullName: "",
      emailId: state.emailId,
      countryId: 0,
      favTeamId: "",
      phoneNo:
        /* state.mobileNo
        ? state.mobileNo
        : props.loginData.userData.mobileNo */ "",
      otp: isSubmitOTP ? getEmailOTPString() : "",
      countryCode: /* isSubmitOTP ? "" : state.countryCode.split("(")[0] */ "",
      language: config.language,
    };
    self.setState({
      isOtpInvalid: false,
    });
    props.loginData.makeCustomEmailLogin(
      apiParams,
      (resp) => {
        if (isSubmitOTP) {
          props.loginData.setIsShowLoginPopup(false);
          clearAllBodyScrollLocks();

          makeUserGamedaysCall();
          if (leagueCode && leagueName && userName) {
            setLocalStorage("lgCod", "");
            setLocalStorage("lgNam", "");
            setLocalStorage("UsrNam", "");
            console.log(self.props);
            window.location.replace(
              `${config.BASE_DOMAIN_LANG}leagues/${leagueCode}/${leagueName}/${userName}`
            );
          }
        } else {
          props.loginData.setUserData({
            mobileNo: state.mobileNo,
            countryCode: state.countryCode,
            emailId: state.emailId,
          });
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.emailOtp,
            isCustomOTP: true,
            isTimer: true,
          });
          self.initiateOTPTimer();
        }
      },
      (error) => {
        let retVal = error?.RetVal;
        self.setState({
          objEmailOTPStrng: {
            first: "",
            second: "",
            third: "",
            fourth: "",
          },
        });
        if (retVal === 2) {
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.register,
          });
        }
        if (retVal === 1001) {
          self.setState({
            isOtpInvalid: true,
          });
          self.ref0.focus();
        }
        if (retVal === 1006 || retVal === 1011) {
          self.props.loginData.setIsShowLoginPopup(false);
          self.props.loginData.makeLogoutCall({ isReload: true });
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.main,
          });
        }
        if (retVal === -42) {
          self.setState({
            isEmailInvalid: true,
          });
        }
        if (retVal === 10010) {
          self.props.loginData.setIsShowLoginPopup(false);
          self.props.showHideToast(
            true,
            getTrans(
              self.props.TransData.data,
              "auth_v2_unable_to_link_c_custom_10010_msg",
              "Email is black listed {{email_id}}"
            ).replace("{{email_id}}", state.emailId),
            true
          );
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.main,
          });
        }
        if (retVal === 2001) {
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.linkAccounts,
          });
        }
      }
    );
  };
  customLogin = (isSubmitOTP) => {
    const { action, category, label } = config.trackclickEvents.customLogin;
    let leagueCode = getLocalStorage("lgCod");
    let leagueName = getLocalStorage("lgNam");
    let userName = getLocalStorage("UsrNam");
    googleAnalyticsEventTracking(action, category, label);
    let self = this;
    let { state, props, getOTPString, makeUserGamedaysCall } = self;
    let apiParams = {
      optType: isSubmitOTP ? 2 : 1,
      userId: 0,
      socialId: "",
      clientId: 5,
      platformId: config.platformId,
      fullName: "",
      emailId: "",
      countryId: 0,
      favTeamId: "",
      phoneNo: state.mobileNo
        ? state.mobileNo
        : props.loginData.userData.mobileNo,
      otp: isSubmitOTP ? getOTPString() : "",
      countryCode: isSubmitOTP ? "" : state.countryCode.split("(")[0],
      language: config.language,
    };
    self.setState({
      isOtpInvalid: false,
    });
    props.loginData.makeCustomLogin(
      apiParams,
      (resp) => {
        if (isSubmitOTP) {
          props.loginData.setIsShowLoginPopup(false);
          clearAllBodyScrollLocks();

          makeUserGamedaysCall();
          if (leagueCode && leagueName && userName) {
            setLocalStorage("lgCod", "");
            setLocalStorage("lgNam", "");
            setLocalStorage("UsrNam", "");
            console.log(self.props);
            window.location.replace(
              `${config.BASE_DOMAIN_LANG}leagues/${leagueCode}/${leagueName}/${userName}`
            );
          }
          clearInterval(self.timerID);
        } else {
          props.loginData.setUserData({
            mobileNo: state.mobileNo,
            countryCode: state.countryCode,
          });
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.otp,
            isCustomOTP: true,
            isTimer: true,
          });
          self.initiateOTPTimer();
        }
      },
      (error) => {
        let retVal = error?.RetVal;
        self.setState({
          objOTPStrng: {
            first: "",
            second: "",
            third: "",
            fourth: "",
          },
        });
        if (retVal === 2) {
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.register,
          });
        }
        if (retVal === 2001) {
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.linkAccounts,
          });
        }
        if (retVal === 1001) {
          self.setState({
            isOtpInvalid: true,
          });
          self.ref0.focus();
        }
        if (retVal === 2002) {
          props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.changeNumber,
          });
        }
      }
    );
  };

  customEmailVerify = () => {
    let self = this;
    let { state, props, showHideToast } = self;
    let apiParams = {
      optType: 1,
      platformId: config.platformId,
      emailId: state.emailId,
      otp: "",
      clientId: 5,
      language: config.language,
    };
    props.loginData.submitEmail(
      apiParams,
      (resp) => {
        props.loginData.setUserData({
          mobileNo: state.mobileNo,
          countryCode: state.countryCode,
          emailId: getLoginCookie()?.EmailId,
        });
        props.loginData.setObjShowHideLogin({
          screenMode: config.loginScreenMode.emailOtp,
          isTimer: true,
        });
        self.initiateOTPTimer();
        this.ref0.focus();
      },
      (error) => {
        console.log(error);
        let retVal = error?.RetVal;
        if (retVal === 10001) {
          self.setState({
            isEmailInvalid: true,
          });
        } else if (retVal === 1004) {
          self.props.loginData.setIsShowLoginPopup(false);
          self.props.loginData.makeLogoutCall({ isReload: false });
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.main,
          });
          self.props.showHideToast(
            true,
            getTrans(props.TransData.data, "User_not_found", "User not found"),
            true
          );
        } else if (retVal === 1006 || retVal === 1011) {
          self.props.loginData.setIsShowLoginPopup(false);
          self.props.loginData.makeLogoutCall({ isReload: true });
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.main,
          });
        } else if (retVal === 10010) {
          self.props.loginData.setIsShowLoginPopup(false);
          self.props.showHideToast(
            true,
            getTrans(
              self.props.TransData.data,
              "auth_v2_unable_to_link_c_custom_10010_msg",
              "Email is black listed {{email_id}}"
            ).replace("{{email_id}}", state.emailId),
            true
          );
          self.props.loginData.setObjShowHideLogin({
            screenMode: config.loginScreenMode.main,
          });
        } else if (retVal === 2022) {
          let msg = getTrans(
            self.props.TransData.data,
            "auth_v2_unable_to_link_2022_msg",
            "The Email Id: {{email_Ic_social_d}} is already used"
          ).replace("{{email_Ic_social_d}}", getLoginCookie().EmailId);
          self.props.showHideToast(true, msg, true);
        }
      }
    );
  };

  resendTracking = () => {
    const { action, category, label } = config.trackclickEvents.resendOtp;
    googleAnalyticsEventTracking(action, category, label);
  };

  redirectToMain = () => {
    let self = this;
    self.props.loginData.setObjShowHideLogin({
      screenMode: config.loginScreenMode.main,
    });
    self.setState({
      mobileNo: "",
      countryCode: "+971(UAE)",
      isCntrDrpDwnOpen: false,
      objOTPStrng: { first: "", second: "", third: "", fourth: "" },
      objEmailOTPStrng: { first: "", second: "", third: "", fourth: "" },
      objCountry: self.props.CompositionData.countriesList[0],
      favClub: {},
      city: {},
      emailId: "",
      userName: "",
      isCityDrpdwnOpen: false,
      isFavClubDrpdwnOpen: false,
      objEmailErr: { isShow: false, errMsg: "" },
      objMobileErr: { isShow: false, errMsg: "" },
      isValidated: false,
      isOtpInvalid: false,
    });
  };

  countryCodeSearchHandler = (e) => {
    this.setState({ countryCodeSearch: e.target.value });
  };

  registerMobile = (e) => {
    e.preventDefault();
    let self = this;
    self.props.loginData.setObjShowHideLogin({
      screenMode: config.loginScreenMode.mobileNo,
    });
    self.props.loginData.setIsShowLoginPopup(true);
  };

  initiateOTPTimer = () => {
    let self = this;
    let serverDates = new Date(window.serverDate);
    var mutatedDeadLine = new Date(serverDates.getTime());
    mutatedDeadLine = new Date(
      mutatedDeadLine.setSeconds(mutatedDeadLine.getSeconds() - config.otpTimer)
    );
    clearInterval(self.timerID);
    if (!serverDates) {
      serverDates = new Date();
    }
    let objDuration = Date.daysBetween(mutatedDeadLine, serverDates);
    self.setState({
      objDuration: objDuration,
    });
    self.timerID = setInterval(() => {
      mutatedDeadLine.setSeconds(mutatedDeadLine.getSeconds() + 1);

      objDuration = Date.daysBetween(mutatedDeadLine, serverDates);
      self.setState({
        objDuration: objDuration,
      });
      if (objDuration.seconds === 0) {
        clearInterval(self.timerID);
        self.props.loginData.setObjShowHideLogin({
          ...self.props.loginData.objShowHideLogin,
          isTimer: false,
        });
      }
    }, 1000);
  };

  render() {
    let self = this;
    let {
      state,
      props,
      updatedMobileNo,
      onChangeMobileNo,
      onUpdateOTP,
      onClose,
      socialLogin,
      selectCountryCode,
      showHideCountryDropdown,
      submitMobileNoForOTP,
      showHideCountryCodeDropdown,
      onChangeOTP,
      selectCountry,
      selectCity,
      onChangeEmail,
      onChangeUserName,
      showHideCityDropdown,
      showHideFavClubDrpdwn,
      onChangeFavClub,
      registerUser,
      redirectToOTP,
      redirectToMain,
      customLogin,
      resendTracking,
      customEmailVerify,
      onChangeEmailOTP,
      onUpdateEmailOTP,
      customEmailLogin,
      linkingSocialLogin,
    } = self;
    let {
      closeModal,
      mobileNo,
      countryCode,
      isCntrDrpDwnOpen,
      objOTPStrng,
      objEmailOTPStrng,
      objCountry,
      city,
      favClub,
      emailId,
      userName,
      isCityDrpdwnOpen,
      isFavClubDrpdwnOpen,
      objEmailErr,
      objMobileErr,
      isValidated,
      isOtpInvalid,
      isContinueEnable,
      isCountryCodeOpen,
      objDuration,
    } = state;
    let { loginData, CompositionData, TransData } = props;
    const transData = TransData.data;
    let { first, second, third, fourth } = objOTPStrng;
    let sActiveClass = "si-active";
    let sPickedClass = "si-picked";
    let sDisabledClass = "si-disabled";
    let loginHead = null;
    let loginBody = null;
    let loginCookie = getLoginCookie();
    /* let overallHeight = document.querySelector('.si-popup__container').clientHeight;
    let topH = document.querySelector('.si-popup__head').clientHeight;

    let height =  overallHeight - topH */
    let seconds = objDuration.seconds ? objDuration.seconds : "59";
    let sTimerText = "00:" + seconds.toString().padStart(2, "0");
    if (loginData.objShowHideLogin.screenMode === config.loginScreenMode.main) {
      loginHead = getTrans(transData, "login_register", "Login / Register");
      loginBody = (
        <div className="si-popup__body" style={{}}>
          {/* <Scrollbars className="si-scroll_js"> */}
          <div className="si-login__box">
            <div className="si-login__info">
              <span>
                {getTrans(
                  transData,
                  "auth_v2_past_mobile_account_msg",
                  "Loggedin via Mobile Number in the past?"
                )}{" "}
                <a
                  href=""
                  onClick={(e) => {
                    this.registerMobile(e);
                  }}
                >
                  {getTrans(
                    transData,
                    "auth_v2_past_mobile_account_click_here",
                    "Click Here"
                  )}
                </a>
              </span>
            </div>
            <div className="si-login__form">
              {state.isEmailInvalid ? (
                <div className="si-frm-errMsg" style={{ marginBottom: "5px" }}>
                  <span style={{ color: "red" }}>
                    {getTrans(
                      transData,
                      "Enter_Correct_emailId",
                      "Invalid Email. Please Enter Correct Email"
                    )}
                  </span>
                </div>
              ) : null}
              <div className="si-login__code si-login__code--mail">
                <div className="si-form__control">
                  <div className="si-input">
                    {/* <!-- si-input--danger | si-input--success --> */}
                    <input
                      type="mail"
                      className=""
                      placeholder="Email"
                      value={emailId}
                      onChange={(e) => onChangeEmail(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="si-login__content">
              <span>
                {getTrans(
                  transData,
                  "Login_PopUp_Bottom_txt",
                  "By continuing, I agree to the UAE Pro League’s"
                )}{" "}
                <br />{" "}
                <a
                  href={config.BASE_DOMAIN_LANG + "terms"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getTrans(transData, "Terms_Of_Use", "Terms of Use")}
                </a>
                {"  "}
                {getTrans(transData, "Regist_And")}
                {"  "}
                <a
                  href={config.BASE_DOMAIN_LANG + "privacy"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getTrans(transData, "Privacy_Policy", "Privacy Policy")}{" "}
                </a>
              </span>
            </div>
            <div className="si-login__CTA">
              <div
                className={
                  "si-btn si-btn__primary " /* +
                  (isContinueEnable ? "" : sDisabledClass) */
                }
                onClick={() => customEmailLogin()}
              >
                <span>{getTrans(transData, "Continue_Btn", "Continue")}</span>
              </div>
            </div>
          </div>
          <div className="si-invite__or">
            <span>
              {getTrans(transData, "Or_Login_Via_txt", "Or Login via")}
            </span>
          </div>
          <div className="si-share__box">
            <ul>
              <li onClick={() => socialLogin(config.socialLogin.facebook)}>
                <img
                  src={`${config.IMG_BASE}facebook.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Login_PopUp_FaceBook_Alt_Txt",
                    "Login with Facebook"
                  )}
                  title={getTrans(
                    transData,
                    "Login_PopUp_FaceBook_Title_Txt",
                    "Login with Facebook"
                  )}
                />
              </li>
              {/* <li onClick={() => socialLogin(config.socialLogin.twitter)}>
                <img
                  src={`${config.IMG_BASE}twitter.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Login_PopUp_Twitter_Alt_Txt",
                    "Login with Twitter"
                  )}
                  title={getTrans(
                    transData,
                    "Login_PopUp_Twitter_Title_Txt",
                    "Login with Twitter"
                  )}
                />
              </li> */}
              <li onClick={() => socialLogin(config.socialLogin.google)}>
                <img
                  src={`${config.IMG_BASE}gmail.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Login_PopUp_Gmail_Alt_Txt",
                    "Login with Gmail"
                  )}
                  title={getTrans(
                    transData,
                    "Login_PopUp_Gmail_Title_Txt",
                    "Login with Gmail"
                  )}
                />
              </li>
            </ul>
          </div>
          {/* </Scrollbars> */}
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode === config.loginScreenMode.mobileNo
    ) {
      loginHead = getTrans(
        transData,
        "auth_v2_login_via_mobile_no_title",
        "Login via mobile Number"
      );
      loginBody = (
        <div className="si-popup__body" /* style={{ height: "306px" }} */>
          {/* <Scrollbars className="si-scroll_js"> */}
          <div className="si-login__box">
            <div className="si-login__info">
              <span>
                {getTrans(
                  transData,
                  "enter_a_mobile_number_for_login",
                  "Enter a mobile number for login"
                )}
              </span>
            </div>
            <div className="si-login__form">
              <div className="si-login__code">
                <OutsideNotifier handler={() => showHideCountryDropdown(false)}>
                  <div
                    className={
                      "si-drpDwn " + (isCntrDrpDwnOpen ? sActiveClass : "")
                    }
                    onClick={() => {
                      showHideCountryDropdown(!isCntrDrpDwnOpen);
                    }}
                  >
                    <div className={"si-drpDwn__value " + sPickedClass}>
                      <span>{countryCode}</span>
                      {/* <div
                      className="si-form__control hide-mob"
                      onClick={() => {
                        showHideCountryDropdown(true);
                      }}
                    >
                      <div className="si-input si-input--search ">
                        <input
                          type="text"
                          className=""
                          placeholder={getTrans(transData,"search","Search")}
                          ref={(input) => (this.refCntrCode = input)}
                        />
                        <div className="si-input--icon"></div>
                      </div>
                    </div> */}
                      <select>
                        {CompositionData.countriesList?.map((elem, ind) => {
                          return (
                            <option
                              key={ind}
                              onClick={() => {
                                selectCountryCode(elem);
                              }}
                            >
                              {elem.DialingCode}({elem.ShortCode})
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="si-drpDwn__list">
                      <Scrollbars className="si-scroll_js">
                        <div
                          className="si-form__control"
                          onClick={() => {
                            showHideCountryDropdown(true);
                          }}
                        >
                          <div className="si-input si-input--search ">
                            <input
                              type="text"
                              className=""
                              ref={(input) => (this.refCntrCode = input)}
                              placeholder={getTrans(
                                transData,
                                "search",
                                "Search"
                              )}
                              value={this.state.countryCodeSearch}
                              onChange={(e) => this.countryCodeSearchHandler(e)}
                            />
                            <div className="si-input--icon"></div>
                          </div>
                        </div>

                        <ul>
                          {CompositionData.countriesList
                            ?.filter((country) => {
                              let searchValue = this.state.countryCodeSearch
                                .toLocaleLowerCase()
                                .trim();
                              return (
                                country.DialingCode.toLocaleLowerCase().includes(
                                  searchValue
                                ) ||
                                country.ShortCode.toLocaleLowerCase().includes(
                                  searchValue
                                ) ||
                                country.Name.toLocaleLowerCase().includes(
                                  searchValue
                                )
                              );
                            })
                            .map((elem, ind) => {
                              return (
                                <li
                                  key={ind}
                                  onClick={() => {
                                    selectCountryCode(elem);
                                  }}
                                >
                                  {elem.DialingCode}({elem.Name})
                                </li>
                              );
                            })}
                        </ul>
                      </Scrollbars>
                    </div>
                  </div>
                </OutsideNotifier>
                <div className="si-input">
                  <input
                    type="tel"
                    className=""
                    placeholder={getTrans(
                      transData,
                      "Login_PopUp_Placeholder_Txt",
                      "Enter mobile no"
                    )}
                    value={mobileNo}
                    onKeyDown={(event) => {
                      onChangeMobileNo(event);
                    }}
                    onKeyPress={(event) => {
                      updatedMobileNo(event);
                    }}
                    onChange={() => {
                      return;
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="si-login__CTA">
              <div
                className={
                  "si-btn si-btn__primary " +
                  (isContinueEnable ? "" : sDisabledClass)
                }
                onClick={() => {
                  submitMobileNoForOTP();
                }}
              >
                <span>{getTrans(transData, "Continue_Btn", "Continue")}</span>
              </div>
            </div>
          </div>
          {/* </Scrollbars> */}
        </div>
      );
    }
    if (loginData.objShowHideLogin.screenMode === config.loginScreenMode.otp) {
      loginBody = (
        <div className="si-popup__body" /* style={{ height: "389px" }} */>
          {/* <Scrollbars className="si-scroll_js"> */}
          <div className="si-otp__box">
            <div className="si-otp__thumb">
              <img
                src={`${config.IMG_BASE}otp--thumb.svg?v=${config.WebConfig.imgVersion}`}
                alt={getTrans(
                  transData,
                  "Verify_With_OTP_Alt_Txt",
                  "Verify with OTP"
                )}
                title={getTrans(
                  transData,
                  "Verify_With_OTP_Title_Txt",
                  "Verify with OTP"
                )}
              />
            </div>
            <div className="si-otp__heading">
              <span>
                {getTrans(transData, "Verify_With_OTP_Txt", "Verify with OTP")}
              </span>
            </div>
            <div className="si-otp__code">
              <span>
                {getTrans(transData, "OTP_sent_to", "OTP sent to")}{" "}
                <em>
                  {loginData.userData.countryCode.split("(")[0]}{" "}
                  {"XXXXXX" +
                    loginData.userData.mobileNo.slice(
                      loginData.userData.mobileNo.length - 4
                    )}
                </em>
              </span>
            </div>
            <div className="si-otp__title">
              <span>
                {getTrans(
                  transData,
                  "Enter_The_OTP",
                  "Enter the OTP you received"
                )}
              </span>
            </div>
            <div className="si-otp__digits">
              <form
                method="get"
                className="si-digit-group"
                data-group-name="digits"
                data-autosubmit="false"
                autoComplete="off"
              >
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref0 = input)}
                  value={first}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeOTP(
                      event,
                      1,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateOTP(event, 1);
                  }}
                />
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref1 = input)}
                  value={second}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeOTP(
                      event,
                      2,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateOTP(event, 2);
                  }}
                />
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref2 = input)}
                  value={third}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeOTP(
                      event,
                      3,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateOTP(event, 3);
                  }}
                />
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref3 = input)}
                  value={fourth}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeOTP(
                      event,
                      4,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateOTP(event, 4);
                  }}
                />
              </form>
              {isOtpInvalid ? (
                <div
                  className="si-frm-errMsg
                "
                >
                  <span>
                    {getTrans(
                      transData,
                      "Enter_Correct_OTP",
                      "Invalid OTP. Please Enter Correct OTP"
                    )}
                  </span>
                </div>
              ) : null}
            </div>
            <div
              className="si-otp__text"
              onClick={() =>
                !loginData.objShowHideLogin.isTimer && customLogin()
              }
            >
              <span>
                {getTrans(
                  transData,
                  "Didn't_Receive_OTP",
                  "Didn’t receive the OTP?"
                )}{" "}
                <a
                  href="#"
                  onClick={() =>
                    !loginData.objShowHideLogin.isTimer && resendTracking()
                  }
                >
                  {loginData.objShowHideLogin.isTimer
                    ? sTimerText
                    : getTrans(transData, "Resend_OTP", "Resend OTP")}
                </a>
              </span>
            </div>
          </div>
          {/* </Scrollbars> */}
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode === config.loginScreenMode.emailOtp
    ) {
      loginBody = (
        <div className="si-popup__body" /* style={{ height: "389px" }} */>
          {/* <Scrollbars className="si-scroll_js"> */}
          <div className="si-otp__box">
            <div className="si-otp__thumb">
              <img
                src={`${config.IMG_BASE}otp--mail-thumb.svg?v=${config.WebConfig.imgVersion}`}
                alt={getTrans(
                  transData,
                  "Verify_With_OTP_Alt_Txt",
                  "Verify with OTP"
                )}
                title={getTrans(
                  transData,
                  "Verify_With_OTP_Title_Txt",
                  "Verify with OTP"
                )}
              />
            </div>
            <div className="si-otp__heading">
              <span>{getTrans(transData, "enter_otp", "Enter OTP")}</span>
            </div>
            <div className="si-otp__code">
              <span>
                {getTrans(transData, "OTP_sent_to", "OTP sent to")}{" "}
                <em>
                  {loginData.userData.emailId}
                  {/* {" "}
                  {"XXXXXX" +
                    loginData.userData.mobileNo.slice(
                      loginData.userData.mobileNo.length - 4
                    )} */}
                </em>
              </span>
            </div>
            <div className="si-otp__title">
              <span>
                {getTrans(
                  transData,
                  "Enter_The_OTP",
                  "Enter the OTP you received"
                )}
              </span>
            </div>
            <div className="si-otp__digits">
              <form
                method="get"
                className="si-digit-group"
                data-group-name="digits"
                data-autosubmit="false"
                autoComplete="off"
              >
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref0 = input)}
                  value={objEmailOTPStrng.first}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeEmailOTP(
                      event,
                      1,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateEmailOTP(event, 1);
                  }}
                />
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref1 = input)}
                  value={objEmailOTPStrng.second}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeEmailOTP(
                      event,
                      2,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateEmailOTP(event, 2);
                  }}
                />
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref2 = input)}
                  value={objEmailOTPStrng.third}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeEmailOTP(
                      event,
                      3,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateEmailOTP(event, 3);
                  }}
                />
                <input
                  type="tel"
                  maxLength={1}
                  ref={(input) => (this.ref3 = input)}
                  value={objEmailOTPStrng.fourth}
                  onChange={() => {
                    return;
                  }}
                  onKeyPress={(event) =>
                    onChangeEmailOTP(
                      event,
                      4,
                      loginData.objShowHideLogin.isCustomOTP
                    )
                  }
                  onKeyDown={(event) => {
                    onUpdateEmailOTP(event, 4);
                  }}
                />
              </form>
              {isOtpInvalid ? (
                <div
                  className="si-frm-errMsg
                "
                >
                  <span>
                    {getTrans(
                      transData,
                      "Enter_Correct_OTP",
                      "Invalid OTP. Please Enter Correct OTP"
                    )}
                  </span>
                </div>
              ) : null}
            </div>
            <div
              className="si-otp__text"
              onClick={() =>
                !loginData.objShowHideLogin.isTimer && customEmailLogin()
              }
            >
              <span>
                {getTrans(
                  transData,
                  "Didn't_Receive_OTP",
                  "Didn’t receive the OTP?"
                )}{" "}
                <a
                  href="#"
                  onClick={() =>
                    !loginData.objShowHideLogin.isTimer && resendTracking()
                  }
                >
                  {loginData.objShowHideLogin.isTimer
                    ? sTimerText
                    : getTrans(transData, "Resend_OTP", "Resend OTP")}
                </a>
              </span>
            </div>
          </div>
          {/* </Scrollbars> */}
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode === config.loginScreenMode.register
    ) {
      loginHead = getTrans(
        transData,
        "Complete_Sign_Up",
        "Complete your sign up"
      );
      loginBody = (
        <>
          <div className="si-popup__body" /*  style={{ height: "378px" }} */>
            {/* <Scrollbars className="si-scroll_js"> */}
            <div className="si-login__box">
              <div className="si-mobile__validate">
                <div className="si-mobile__lhs">
                  <div className="si-mobile__lbl">
                    <span>
                      {getTrans(transData, "Email_Placeholder_Txt", "Email")}
                    </span>
                  </div>
                  <div className="si-mobile__number">
                    <span>
                      {loginCookie?.EmailId}
                      {/* {loginData.userData.countryCode.split("(")[0]}{" "}
                      {"XXXXXX" +
                        loginData.userData.mobileNo.slice(
                          loginData.userData.mobileNo.length - 4
                        )} */}
                    </span>
                  </div>
                </div>
                <div className="si-mobile__rhs">
                  <img
                    src={`${config.IMG_BASE}mobile-tick.svg?v=${config.WebConfig.imgVersion}`}
                    alt={getTrans(
                      transData,
                      "Mobile_No_Validate_Alt_Txt",
                      "Mobile Number Validated"
                    )}
                    title={getTrans(
                      transData,
                      "Mobile_No_Validate_Title_Txt",
                      "Mobile Number Validated"
                    )}
                  />
                </div>
              </div>
              <div className="si-login__form">
                <div className="si-form__control">
                  <div className="si-login__code" style={{ marginBottom: 0 }}>
                    <OutsideNotifier
                      handler={() => showHideCountryCodeDropdown(false)}
                    >
                      <div
                        className={
                          "si-drpDwn " + (isCountryCodeOpen ? sActiveClass : "")
                        }
                        onClick={() => {
                          showHideCountryCodeDropdown(!isCountryCodeOpen);
                        }}
                      >
                        <div className={"si-drpDwn__value " + sPickedClass}>
                          <span>{countryCode}</span>
                          {/* <div
                      className="si-form__control hide-mob"
                      onClick={() => {
                        showHideCountryDropdown(true);
                      }}
                    >
                      <div className="si-input si-input--search ">
                        <input
                          type="text"
                          className=""
                          placeholder={getTrans(transData,"search","Search")}
                          ref={(input) => (this.refCntrCode = input)}
                        />
                        <div className="si-input--icon"></div>
                      </div>
                    </div> */}
                          <select>
                            {CompositionData.countriesList?.map((elem, ind) => {
                              return (
                                <option
                                  key={ind}
                                  onClick={() => {
                                    selectCountryCode(elem);
                                  }}
                                >
                                  {elem.DialingCode}({elem.ShortCode})
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="si-drpDwn__list">
                          <Scrollbars className="">
                            <div
                              className="si-form__control"
                              onClick={() => {
                                showHideCountryDropdown(true);
                              }}
                            >
                              <div className="si-input si-input--search ">
                                <input
                                  type="text"
                                  className=""
                                  ref={(input) => (this.refCntCode = input)}
                                  placeholder={getTrans(
                                    transData,
                                    "search",
                                    "Search"
                                  )}
                                  value={this.state.countryCodeSearch}
                                  onChange={(e) =>
                                    this.countryCodeSearchHandler(e)
                                  }
                                />
                                <div className="si-input--icon"></div>
                              </div>
                            </div>

                            <ul>
                              {CompositionData.countriesList
                                ?.filter((country) => {
                                  let searchValue = this.state.countryCodeSearch
                                    .toLocaleLowerCase()
                                    .trim();
                                  return (
                                    country.DialingCode.toLocaleLowerCase().includes(
                                      searchValue
                                    ) ||
                                    country.ShortCode.toLocaleLowerCase().includes(
                                      searchValue
                                    ) ||
                                    country.Name.toLocaleLowerCase().includes(
                                      searchValue
                                    )
                                  );
                                })
                                .map((elem, ind) => {
                                  return (
                                    <li
                                      key={ind}
                                      onClick={() => {
                                        selectCountryCode(elem);
                                      }}
                                    >
                                      {elem.DialingCode}({elem.Name})
                                    </li>
                                  );
                                })}
                            </ul>
                          </Scrollbars>
                        </div>
                      </div>
                    </OutsideNotifier>
                    <div className="si-input">
                      <input
                        type="tel"
                        className=""
                        placeholder={
                          getTrans(transData, "Mobile_No.", "Mobile Number") +
                          "*"
                        }
                        value={mobileNo}
                        onKeyDown={(event) => {
                          onChangeMobileNo(event);
                        }}
                        onKeyPress={(event) => {
                          updatedMobileNo(event);
                        }}
                        onChange={() => {
                          return;
                        }}
                      />
                    </div>
                  </div>
                  {objMobileErr.isShow ? (
                    <div className="si-frm-errMsg" style={{ color: "red" }}>
                      <span>
                        {getTrans(
                          transData,
                          "auth_v2_unable_to_register_10011_msg",
                          "Phone number already exists"
                        )}
                      </span>
                    </div>
                  ) : null}
                </div>
                <div className="si-form__control">
                  <div className="si-input">
                    <input
                      type="text"
                      className=""
                      placeholder={
                        getTrans(
                          transData,
                          "Username_Placeholder_Txt",
                          "Username"
                        ) + "*"
                      }
                      value={userName}
                      onChange={(e) => onChangeUserName(e)}
                    />
                  </div>
                  <div className="si-frm-errMsg">
                    <span>
                      {getTrans(
                        transData,
                        "Login_Form_Info_Txt",
                        "This name will be used on Fantasy & Predictor game Max 25 & Min 3 Characters"
                      )}
                    </span>
                  </div>
                </div>
                <div className="si-form__control">
                  <OutsideNotifier
                    handler={() => showHideCountryDropdown(false)}
                  >
                    <div
                      className={
                        "si-drpDwn si-up " +
                        (isCntrDrpDwnOpen ? sActiveClass : "")
                      }
                      onClick={() => showHideCountryDropdown(!isCntrDrpDwnOpen)}
                    >
                      <div className="si-drpDwn__value si-picked ">
                        <div
                          className="si-club__thumb"
                          style={{
                            backgroundImage: `url(${config.IMG_BASE}countries/${objCountry.Id}.png?v=${config.WebConfig.imgVersion})`,
                          }}
                        ></div>
                        <div className="si-club__name">{objCountry.Name}</div>
                        <select>
                          {CompositionData.countriesList?.map((elem, ind) => {
                            return (
                              <option
                                key={ind}
                                className={
                                  elem.Id === objCountry.Id ? sActiveClass : ""
                                }
                                onClick={() => {
                                  selectCountry(elem);
                                }}
                              >
                                {elem.Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="si-drpDwn__list">
                        <Scrollbars className="si-scroll_js">
                          <div className="si-filter__search">
                            <div
                              className="si-form__control"
                              onClick={() => {
                                showHideCountryDropdown(true);
                              }}
                            >
                              <div className="si-input si-input--search ">
                                <input
                                  type="text"
                                  className=""
                                  ref={(input) => (this.refCntrCode = input)}
                                  placeholder={getTrans(
                                    transData,
                                    "search",
                                    "Search"
                                  )}
                                  value={this.state.countryCodeSearch}
                                  onChange={(e) =>
                                    this.countryCodeSearchHandler(e)
                                  }
                                />
                                <div className="si-input--icon"></div>
                              </div>
                            </div>
                          </div>
                          <ul>
                            {CompositionData.countriesList
                              ?.filter((country) => {
                                let searchValue = this.state.countryCodeSearch
                                  .toLocaleLowerCase()
                                  .trim();
                                return country.Name.toLocaleLowerCase().includes(
                                  searchValue
                                );
                              })
                              .map((elem, ind) => {
                                return (
                                  <li
                                    key={ind}
                                    className={
                                      elem.Id === objCountry.Id
                                        ? sActiveClass
                                        : ""
                                    }
                                    onClick={() => {
                                      selectCountry(elem);
                                    }}
                                  >
                                    <div className="si-club__box">
                                      <div
                                        className="si-club__thumb"
                                        style={{
                                          backgroundImage: `url(${config.IMG_BASE}countries/${elem.Id}.png?v=${config.WebConfig.imgVersion})`,
                                        }}
                                      ></div>
                                      <div className="si-club__name">
                                        <span>{elem.Name}</span>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </Scrollbars>
                      </div>
                    </div>
                  </OutsideNotifier>
                </div>
                {objCountry.cities?.length ? (
                  <div className="si-form__control">
                    <OutsideNotifier
                      handler={() => showHideCityDropdown(false)}
                    >
                      <div
                        className={
                          "si-drpDwn si-up  " +
                          (isCityDrpdwnOpen ? sActiveClass : "")
                        }
                        onClick={() => showHideCityDropdown(!isCityDrpdwnOpen)}
                      >
                        <div
                          className={
                            "si-drpDwn__value " +
                            (Object.keys(city).length ? sPickedClass : "")
                          }
                        >
                          <span>
                            {Object.keys(city).length
                              ? city.Name
                              : getTrans(
                                  transData,
                                  "Select_Emirates",
                                  "Select Emirates"
                                ) + "*"}
                          </span>
                          <select>
                            {objCountry.cities?.map((elem, ind) => {
                              return (
                                <option
                                  key={ind}
                                  onClick={() => {
                                    selectCity(elem);
                                  }}
                                  className={
                                    elem.Id === city.Id ? sActiveClass : ""
                                  }
                                >
                                  {elem.Name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="si-drpDwn__list">
                          <Scrollbars className="si-scroll_js">
                            <ul>
                              {objCountry.cities?.map((elem, ind) => {
                                return (
                                  <li
                                    key={ind}
                                    onClick={() => {
                                      selectCity(elem);
                                    }}
                                    className={
                                      elem.Id === city.Id ? sActiveClass : ""
                                    }
                                  >
                                    {elem.Name}
                                  </li>
                                );
                              })}
                            </ul>
                          </Scrollbars>
                        </div>
                      </div>
                    </OutsideNotifier>
                  </div>
                ) : null}
                <div className="si-form__control">
                  <OutsideNotifier handler={() => showHideFavClubDrpdwn(false)}>
                    <div
                      className={
                        "si-drpDwn si-up " +
                        (isFavClubDrpdwnOpen ? sActiveClass : "")
                      }
                      onClick={() =>
                        showHideFavClubDrpdwn(!isFavClubDrpdwnOpen)
                      }
                    >
                      <div
                        className={
                          "si-drpDwn__value " +
                          (Object.keys(favClub).length ? sPickedClass : "")
                        }
                      >
                        {Object.keys(favClub).length ? (
                          <>
                            <div
                              className="si-club__thumb"
                              style={{
                                backgroundImage: `url(${config.IMG_BASE}clubs/${favClub.TeamId}.png?v=${this.props.ConstraintsData?.data?.PlayerJerseyTeamVersion})`,
                              }}
                            ></div>
                            <div className="si-club__name">
                              {favClub.WebName}
                            </div>
                          </>
                        ) : (
                          <span>
                            {getTrans(
                              transData,
                              "Club_You_Support",
                              "Club you support"
                            ) + "*"}
                          </span>
                        )}
                        <select>
                          {CompositionData.TeamListContextData?.map(
                            (elem, ind) => {
                              return (
                                <option
                                  key={ind}
                                  onClick={() => onChangeFavClub(elem)}
                                  className={
                                    elem.TeamId === favClub.TeamId
                                      ? sActiveClass
                                      : ""
                                  }
                                >
                                  {elem.WebName}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>
                      <div className="si-drpDwn__list">
                        <Scrollbars className="si-scroll_js">
                          <ul>
                            {CompositionData.TeamListContextData?.map(
                              (elem, ind) => {
                                return (
                                  <li
                                    key={ind}
                                    onClick={() => {
                                      onChangeFavClub(elem);
                                    }}
                                    className={
                                      elem.TeamId === favClub.TeamId
                                        ? sActiveClass
                                        : ""
                                    }
                                  >
                                    <div className="si-club__box">
                                      <div
                                        className="si-club__thumb"
                                        style={{
                                          backgroundImage: `url(${config.IMG_BASE}clubs/${elem.TeamId}.png?v=${this.props.ConstraintsData?.data?.PlayerJerseyTeamVersion})`,
                                        }}
                                      ></div>
                                      <div className="si-club__name">
                                        <span>{elem.WebName}</span>
                                      </div>
                                    </div>
                                  </li>
                                );
                              }
                            )}
                          </ul>
                        </Scrollbars>
                      </div>
                    </div>
                  </OutsideNotifier>
                </div>
              </div>
            </div>
            {/* </Scrollbars> */}
          </div>
          <div className="si-popup__foot">
            <div
              className={
                "si-btn si-btn__primary " + (isValidated ? "" : sDisabledClass)
              }
              onClick={() => isValidated && registerUser()}
            >
              <span>
                {getTrans(transData, "Create_Account", "Create Account")}
              </span>
            </div>
          </div>
        </>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode ===
      config.loginScreenMode.linkAccounts
    ) {
      loginBody = (
        <div className="si-popup__body" /* style={{ height: "350px" }} */>
          {/* <Scrollbars className="si-scroll_js"> */}
          <div className="si-login__box">
            <div className="si-login__thumb">
              <img
                src={`${config.IMG_BASE}warning-outline.svg?v=${config.WebConfig.imgVersion}`}
                alt=""
                title=""
              />
            </div>
            <div className="si-login__info">
              <span>
                {getTrans(
                  transData,
                  "email_Linked_To_Another_Acc_Msg",
                  "The associated Email Id is already linked to another account."
                )}
              </span>
              <span>
                {getTrans(
                  transData,
                  "Link_With_Acc_Msg",
                  "Do you want to link your account with this"
                )}{" "}
                {getTrans(
                  self.props.TransData.data,
                  config.enumClientIdName[loginCookie.ClientId]
                )}{" "}
                {getTrans(transData, "Account_txt_With_Q_Mark", "account?")}
              </span>
            </div>
            <div className="si-login__CTA">
              <div
                className="si-btn si-btn__primary si-btn__primary--outline"
                onClick={() => redirectToOTP()}
              >
                <span>{getTrans(transData, "No_Txt", "No")}</span>
              </div>
              <div
                className="si-btn si-btn__primary"
                onClick={() => registerUser(true)}
              >
                <span>{getTrans(transData, "Yes_Txt", "Yes")}</span>
              </div>
            </div>
            <div
              className="si-login__text"
              onClick={() => {
                redirectToMain();
              }}
            >
              <span>
                {getTrans(transData, "Already_User_Txt", "Already a user?")}{" "}
                <a href="#">{getTrans(transData, "Log_In", "LOG IN")}</a>
              </span>
            </div>
          </div>
          {/* </Scrollbars> */}
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode ===
      config.loginScreenMode.linkNewLogin
    ) {
      loginHead = getTrans(transData, "login_register", "Login / Register");
      loginBody = (
        <div className="si-popup__body" style={{}}>
          {/* <Scrollbars className="si-scroll_js"> */}
          <div className="si-login__box">
            <div
              className="si-login__info si-text--redDark"
              style={{ marginBottom: "20px" }}
            >
              <p>
                {getTrans(
                  transData,
                  "auth_v2_account_link_msg_part_1",
                  "Unfortunately, we had removed the mobile number login due to some technical issues."
                )}
              </p>
              <p>
                <b>
                  {getTrans(
                    transData,
                    "auth_v2_account_link_msg_part_2",
                    "Please link your account to social media or an active email Id to continue using the App"
                  )}
                </b>
              </p>
            </div>
            <div className="si-login__form">
              {state.isEmailInvalid ? (
                <div className="si-frm-errMsg" style={{ marginBottom: "5px" }}>
                  <span style={{ color: "red" }}>
                    {getTrans(
                      transData,
                      "Enter_Correct_emailId",
                      "Invalid Email. Please Enter Correct Email"
                    )}
                  </span>
                </div>
              ) : null}
              <div className="si-login__code si-login__code--mail">
                <div className="si-form__control">
                  <div className={`si-input`}>
                    {/* <!-- si-input--danger | si-input--success --> */}
                    <input
                      type="mail"
                      className=""
                      placeholder="Email"
                      value={emailId}
                      onChange={(e) => onChangeEmail(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="si-login__content">
              <span>
                {getTrans(
                  transData,
                  "Login_PopUp_Bottom_txt",
                  "By continuing, I agree to the UAE Pro League’s"
                )}{" "}
                <br />{" "}
                <a
                  href={config.BASE_DOMAIN_LANG + "terms"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getTrans(transData, "Terms_Of_Use", "Terms of Use")}
                </a>
                {"  "}
                {getTrans(transData, "Regist_And")}
                {"  "}
                <a
                  href={config.BASE_DOMAIN_LANG + "privacy"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getTrans(transData, "Privacy_Policy", "Privacy Policy")}{" "}
                </a>
              </span>
            </div>
            <div className="si-login__CTA">
              <div
                className={
                  "si-btn si-btn__primary " /* +
                  (isContinueEnable ? "" : sDisabledClass) */
                }
                onClick={() => customEmailVerify()}
              >
                <span>{getTrans(transData, "Continue_Btn", "Continue")}</span>
              </div>
            </div>
          </div>
          <div className="si-invite__or">
            <span>
              {getTrans(transData, "Or_Login_Via_txt", "Or Login via")}
            </span>
          </div>
          <div className="si-share__box">
            <ul>
              <li
                onClick={() => linkingSocialLogin(config.socialLogin.facebook)}
              >
                <img
                  src={`${config.IMG_BASE}facebook.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Login_PopUp_FaceBook_Alt_Txt",
                    "Login with Facebook"
                  )}
                  title={getTrans(
                    transData,
                    "Login_PopUp_FaceBook_Title_Txt",
                    "Login with Facebook"
                  )}
                />
              </li>
              {/* <li
                onClick={() => linkingSocialLogin(config.socialLogin.twitter)}
              >
                <img
                  src={`${config.IMG_BASE}twitter.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Login_PopUp_Twitter_Alt_Txt",
                    "Login with Twitter"
                  )}
                  title={getTrans(
                    transData,
                    "Login_PopUp_Twitter_Title_Txt",
                    "Login with Twitter"
                  )}
                />
              </li> */}
              <li onClick={() => linkingSocialLogin(config.socialLogin.google)}>
                <img
                  src={`${config.IMG_BASE}gmail.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Login_PopUp_Gmail_Alt_Txt",
                    "Login with Gmail"
                  )}
                  title={getTrans(
                    transData,
                    "Login_PopUp_Gmail_Title_Txt",
                    "Login with Gmail"
                  )}
                />
              </li>
            </ul>
          </div>
          {/* </Scrollbars> */}
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode ===
      config.loginScreenMode.availableAccounts
    ) {
      loginHead = getTrans(
        transData,
        "auth_v2_login_via_mobile_no_title",
        "Login via mobile Number"
      );
      loginBody = (
        <div className="si-login__box">
          <div className="si-login__info">
            <p>
              {getTrans(
                transData,
                "auth_v2_login_via_mobile_no_m̥sg_part_1",
                "Account connected with"
              )}{" "}
              <em>{this.state.loginCookieData?.MobileNo}</em>{" "}
              {self.state.showEmail
                ? getTrans(
                    transData,
                    "auth_v2_login_via_mobile_no_msg_part_2_b",
                    "is already linked with following email id. Please use that to login"
                  )
                : getTrans(
                    transData,
                    "auth_v2_login_via_mobile_no_msg_part_2_a",
                    "is already linked with following social account. Please use that to login"
                  )}{" "}
            </p>
          </div>

          <div className="si-login__socialInput">
            {Number(this.state.loginCookieData?.fbID) != 0 ? (
              <div className="si-login__socialInput-box">
                <span>{getTrans(transData, "Facebook", "Facebook")}</span>
                <img
                  src={`${config.IMG_BASE}link.svg?v=${config.WebConfig.imgVersion}`}
                  alt=""
                />
              </div>
            ) : null}
            {Number(this.state.loginCookieData?.ggID) != 0 ? (
              <div className="si-login__socialInput-box">
                <span>{getTrans(transData, "Google", "Google")}</span>
                <img
                  src={`${config.IMG_BASE}link.svg?v=${config.WebConfig.imgVersion}`}
                  alt=""
                />
              </div>
            ) : null}
            {Number(this.state.loginCookieData?.twID) != 0 ? (
              <div className="si-login__socialInput-box">
                <span>{getTrans(transData, "Twitter", "Twitter")}</span>
                <img
                  src={`${config.IMG_BASE}link.svg?v=${config.WebConfig.imgVersion}`}
                  alt=""
                />
              </div>
            ) : null}
          </div>
          {this.state.showEmail ? (
            <div className="si-mobile__validate">
              <div className="si-mobile__lhs">
                <div className="si-mobile__number">
                  <span>{this.state.loginCookieData?.EmailId}</span>
                </div>
              </div>
              <div className="si-mobile__rhs">
                <img
                  src={`${config.IMG_BASE}mobile-tick.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    "Mobile_No_Validate_Alt_Txt",
                    "Mobile Number Validated"
                  )}
                  title={getTrans(
                    transData,
                    "Mobile_No_Validate_Title_Txt",
                    "Mobile Number Validated"
                  )}
                />
              </div>
            </div>
          ) : null}
          <div className="si-login__CTA">
            <div
              className="si-btn si-btn__primary"
              onClick={() => {
                props.loginData.setObjShowHideLogin({
                  screenMode: config.loginScreenMode.main,
                });
              }}
            >
              <span>
                {getTrans(transData, "auth_v2_go_to_login", "Go to Login")}
              </span>
            </div>
          </div>
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode ===
      config.loginScreenMode.emailProtected
    ) {
      loginHead = getTrans(
        transData,
        "unableRegisterLogin",
        "Unable to Register/Login"
      );
      let retVal_10001 = getTrans(
        transData,
        "emailLinked",
        "Your account is already linked with another {{client_id}} account having the same email Id.\n\n Please use another social media account or register through an active email id."
      ).replace(
        "{{client_id}}",
        getTrans(
          self.props.TransData.data,
          config.enumClientIdName[loginData.objShowHideLogin.clientId]
        )
      );
      let retVal_2002 = getTrans(
        transData,
        "auth_v2_unable_to_link_c_social_10001_msg",
        "Your email Id seems protected on {{client_id}}. Email Id is compulsory to create an account.\n\n Please use another social media account or register through an active email id."
      ).replace(
        "{{client_id}}",
        getTrans(
          self.props.TransData.data,
          config.enumClientIdName[loginData.objShowHideLogin.clientId]
        )
      );
      loginBody = (
        <div className="si-login__box">
          <div className="si-login__info">
            {console.log()}
            <p>
              {loginData.objShowHideLogin?.isRetVal
                ? retVal_2002
                : retVal_10001}
            </p>
          </div>
          <div className="si-login__CTA">
            <div
              className="si-btn si-btn__primary"
              onClick={() => {
                props.loginData.setObjShowHideLogin({
                  screenMode: config.loginScreenMode.main,
                });
              }}
            >
              <span>{getTrans(transData, "auth_v2_ok", "OK")}</span>
            </div>
          </div>
        </div>
      );
    }
    if (
      loginData.objShowHideLogin.screenMode ===
      config.loginScreenMode.unableRegister
    ) {
      loginHead = getTrans(
        transData,
        "unableRegisterLogin",
        "Unable to Register/Login"
      );
      let retVal_10002 = getTrans(
        transData,
        "auth_v2_new_user ",
        "Since you're a new user, please go back to the login page to login via the new custom login"
      );
      loginBody = (
        <div className="si-login__box">
          <div className="si-login__info">
            <p>{retVal_10002}</p>
          </div>
          <div className="si-login__CTA">
            <div
              className="si-btn si-btn__primary"
              onClick={() => {
                props.loginData.setObjShowHideLogin({
                  screenMode: config.loginScreenMode.main,
                });
              }}
            >
              <span>{getTrans(transData, "auth_v2_ok", "OK")}</span>
            </div>
          </div>
        </div>
      );
    }
    if (closeModal) {
      disableBodyScroll(document.querySelector("body"));
    }
    return closeModal ? (
      <React.Fragment>
        <div
          className="si-popup__wrap si-login__popup si-fade in"
          style={{ zIndex: "99999999" }}
        >
          {/* <OutsideNotifier handler={onClose}> */}
          <div className="si-popup__container">
            <div className="si-popup__head">
              <div className="si-popup__close" onClick={onClose}>
                <div className="si-btn__adRe"></div>
              </div>
              {loginHead ? (
                <div className="si-popup__title">
                  <span>{loginHead}</span>
                </div>
              ) : null}
            </div>
            {loginBody}
          </div>
          {/* </OutsideNotifier> */}
        </div>
      </React.Fragment>
    ) : null;
  }
}

export default Consume(LoginPopup, [
  LoginContext,
  TransContext,
  CompositionContext,
  FixturesContext,
  GamedaysContext,
  PlayerListContext,
  TeamDataContext,
  GamerCardContext,
  PlayersStatisticsContext,
  ConstraintsContext,
]);
